import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

/** "Time left of price lock 14m : 59s" — restarts every time the checkout page is opened. */
export function PriceLockTimer({ cfg }) {
  const enabled = cfg.timer_enabled !== false;
  const minutes = Number(cfg.timer_minutes || 15);
  const [left, setLeft] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    const deadline = Date.now() + minutes * 60000;
    const tick = () => setLeft(Math.max(0, Math.floor((deadline - Date.now()) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [enabled, minutes]);

  if (!enabled || left === null) return null;
  const expired = left <= 0;
  const mm = String(Math.floor(left / 60)).padStart(2, '0');
  const ss = String(left % 60).padStart(2, '0');
  return (
    <div
      data-testid="price-lock-timer"
      className={`flex items-center justify-center gap-2 rounded-2xl border px-4 py-2 sm:py-3 text-xs sm:text-sm font-semibold ${expired ? 'border-amber-200 bg-amber-50 text-amber-800' : 'border-slate-200 bg-white text-slate-700'}`}
    >
      <Clock size={16} className={expired ? 'text-amber-600' : 'text-slate-500'} />
      {expired ? (
        <span data-testid="price-lock-expired">{cfg.timer_expired_text}</span>
      ) : (
        <span>
          {cfg.timer_label}
          <span className="font-mono tabular-nums text-slate-900 ml-2" data-testid="price-lock-countdown">{mm}m : {ss}s</span>
        </span>
      )}
    </div>
  );
}
